// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#tour_list[data-v-86381316] .el-input input[type=\"text\"].el-input__inner {\n  height: 36px;\n}\n#tour_list .img-box[data-v-86381316] {\n  width: 60px;\n  height: 60px;\n  border-radius: 8px;\n  overflow: hidden;\n}\n#tour_list .img-box img[data-v-86381316] {\n    width: 100%;\n    height: 100%;\n    -o-object-fit: cover;\n       object-fit: cover;\n}\n", ""]);
// Exports
module.exports = exports;
